export const DEVELOPMENT_MODE_ENV = 'development';
export const PRODUCTION_MODE_ENV = 'production';
